import { Link } from '@tanstack/react-router'
import { FileQuestion } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { m } from '@/lib/paraglide/messages'

export function NotFound() {
    return (
        <div className="h-screen flex flex-col items-center justify-center gap-4 p-8 text-center">
            <FileQuestion className="size-12 text-muted-foreground" />
            <h1 className="text-xl font-semibold">{m.not_found_title()}</h1>
            <p className="text-muted-foreground">{m.not_found_description()}</p>
            <Button asChild>
                <Link to="/">{m.not_found_go_home()}</Link>
            </Button>
        </div>
    )
}
